var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 19.8815H7.5013C2.9763 19.8815 1.04297 17.9482 1.04297 13.4232V8.42318C1.04297 3.89818 2.9763 1.96484 7.5013 1.96484H12.5013C17.0263 1.96484 18.9596 3.89818 18.9596 8.42318V13.4232C18.9596 17.9482 17.0263 19.8815 12.5013 19.8815ZM7.5013 3.21484C3.65964 3.21484 2.29297 4.58151 2.29297 8.42318V13.4232C2.29297 17.2648 3.65964 18.6315 7.5013 18.6315H12.5013C16.343 18.6315 17.7096 17.2648 17.7096 13.4232V8.42318C17.7096 4.58151 16.343 3.21484 12.5013 3.21484H7.5013Z",
    fill: "#B0BECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.04688H6.875C6.53333 9.04688 6.25 8.76354 6.25 8.42188C6.25 8.08021 6.53333 7.79688 6.875 7.79688H13.125C13.4667 7.79688 13.75 8.08021 13.75 8.42188C13.75 8.76354 13.4667 9.04688 13.125 9.04688Z",
    fill: "#B0BECF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.0469H6.875C6.53333 14.0469 6.25 13.7635 6.25 13.4219C6.25 13.0802 6.53333 12.7969 6.875 12.7969H13.125C13.4667 12.7969 13.75 13.0802 13.75 13.4219C13.75 13.7635 13.4667 14.0469 13.125 14.0469Z",
    fill: "#B0BECF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.864cca62c3aec1e84abf957d7bbe84d0.svg";
export { ForwardRef as ReactComponent };